module.exports = __webpack_public_path__ + "img/34_36.2ad23120.png";